import PortalIdParser from 'PortalIdParser';
import { ASSET_TYPES } from 'personalization-lib/constants/assetTypes';

// PERSONALIZATION URLS
const getPersonalizationUrl = () => `/personalization/${PortalIdParser.get()}`;
export const isVariantEditorUrl = url => url.includes(`${getPersonalizationUrl()}/variants/`);
export const getVariantsEditorUrl = strategyId => `${getPersonalizationUrl()}/variants/${strategyId}`;

// ASSET URLS
export const getAssetEditorUrl = ({
  source,
  id
}) => {
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/edit/${id}/content`;
    case ASSET_TYPES.LANDING_PAGE:
      return `/pages/${PortalIdParser.get()}/editor/${id}/content`;
    default:
      return '';
  }
};
export const getAssetDetailsUrl = ({
  source,
  id
}) => {
  switch (source) {
    case ASSET_TYPES.WEB_INTERACTIVE:
      return `/calls-to-action/${PortalIdParser.get()}/details/${id}/performance`;
    case ASSET_TYPES.LANDING_PAGE:
      return `/page-details/${PortalIdParser.get()}/landing-page/${id}/performance`;
    default:
      return '';
  }
};